// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"121fb7a8","548":"3b933996","611":"b6fcc0a6","679":"c23a95bb"}[chunkId] + ".chunk.js";
};